import type { User } from './users';
import type { Company } from './companies';
import type { PublicId } from '../vertices/properties';
import type { Access } from './etc';
import type { Deep } from '../vertices';

export interface Action {
  targetResourceModel?: string;
  operation:            (Access['CREATE'] | Access['READ'] | Access['UPDATE'] | Access['DELETE'])[];
}

export const APP_FEATURE_SELECTORS = ['features::locationBooking', 'features::substitutionPlanner'] as const;
export type AppFeatureSelector = typeof APP_FEATURE_SELECTORS[number];

export const DEFAULT_APP_FEATURE_ACCESS: Record<AppFeatureSelector, boolean> = {
  'features::locationBooking': false,
  'features::substitutionPlanner': true
};

export type Statement = {
  resource:      Pick<Company.complete, 'name'| 'id'> | Pick<Deep.Division, 'displayName' | 'id'>;
  resourceModel: string;
  effect:        boolean;
} & (
  | {
      action: Action;
      type?: 'RESOURCE'; // To make it backwards compatible, we default to 'RESOURCE'
    }
  | {
      selector: AppFeatureSelector[];
      type: 'FEATURE';
    }
);

export type ResourceStatement = Extract<Statement, { type?: 'RESOURCE' }>;
export type FeatureStatement = Extract<Statement, { type: 'FEATURE' }>;

export interface Policy {
  id?:           PublicId;
  users?:        User[];
  inline?:       boolean;
  organization?: Company.complete;
  displayName?:  string;
  description?:  string;
  statements?:   Statement[];
  createdAt?:    Date;
  updatedAt?:    Date;
}